import { State } from '../typings/state';

export const selectClientId = (state: State): string =>
    state.commonData.authorizationData
        ? state.commonData.authorizationData.userId
        : '';
